import { get, set, cloneDeep } from 'lodash'
import { parseUrlPattern } from '../routing-url/utils'
import { addIncrementingSuffix } from '@wix/wix-data-client-common-standalone'
import type { FieldSpec } from '@wix/wix-data-schema-types'
import { FieldType } from '@wix/wix-data-schema-types'

const getFieldKey = (
  prefix: string,
  pattern: string,
  delimiter: string,
): string => {
  const { fields, nonFields } = parseUrlPattern(pattern)
  if (fields.length <= 0) {
    fields.push('all')
  }
  return ['link', prefix].concat(nonFields).concat(fields).join(delimiter)
}

export const generateKey = ({
  prefix,
  pattern,
  existingFieldKeys,
}: {
  prefix: string
  pattern: string
  existingFieldKeys: string[]
}): string => {
  const delimiter = '-'
  const fieldKey = getFieldKey(prefix, pattern, delimiter)
  const uniqueFieldKey = addIncrementingSuffix(
    fieldKey,
    existingFieldKeys,
    delimiter,
  )
  return uniqueFieldKey
}

export const generateDefinition = ({
  pageTitle,
  prefix,
  pattern,
  pageId,
}: {
  pageTitle: string
  prefix: string
  pattern: string
  pageId: string
}): Partial<FieldSpec> => ({
  displayName: pageTitle,
  type: FieldType.pageLink,
  calculator: {
    config: {
      pattern: '/' + prefix + pattern,
      lowercase: true,
    },
  },
  linkedRouterPage: pageId,
})

export const isPageLinkField = (
  field: FieldSpec,
  prefix: string,
  pattern: string,
): boolean =>
  field.type === FieldType.pageLink &&
  get(field, 'calculator.config.pattern') === '/' + prefix + pattern

export const updatePattern = (
  fieldDefinition: FieldSpec,
  newPrefix: string,
  newPattern: string,
): FieldSpec =>
  set(
    cloneDeep(fieldDefinition),
    'calculator.config.pattern',
    '/' + newPrefix + newPattern,
  )

export const updateDisplayName = (
  fieldDefinition: FieldSpec,
  displayName: string,
): FieldSpec => set(cloneDeep(fieldDefinition), 'displayName', displayName)
